import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountService } from 'app/core';
import { Account } from 'app/core/models';
import { RelatedToType } from 'app/shared/enums';
import { TaskRolesResolverData } from './task-roles.types';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';
import { ObjectsManagerService } from '../objects-manager/services/objects-manager.service';

const includeObjects = [RelatedToType.Project, RelatedToType.Property] as string[];

@Injectable()
export class TaskRolesResolver {
  private get account(): Account {
    return this.accountService.getCurrentAccount();
  }

  constructor(
    private readonly accountService: AccountService,
    private readonly objectsManagerService: ObjectsManagerService,
  ) {}

  resolve(): Observable<TaskRolesResolverData> {
    return this.objectsManagerService.get(Number(this.account.id)).pipe(
      map((customObjects: CustomObject[]) => {
        return {
          customObjects,
          relatedToTypes: customObjects
            .filter(({ name }) => includeObjects.includes(name))
            .filter(({ id }) => id === null) // No Custom Objects For Now
            .map(({ name }) => name as RelatedToType),
        };
      }),
    );
  }
}
